module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Banshee-S1.27b7986.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Banshee-S1.jpg
// module id = eIXl
// module chunks = 0